"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promiseTimeout = void 0;
function promiseTimeout(ms, errorFactory, promise) {
    return new Promise(function (resolve, reject) {
        // create a timeout to reject promise if not resolved
        var timer = setTimeout(function () {
            reject(errorFactory());
        }, ms);
        promise
            .then(function (res) {
            clearTimeout(timer);
            resolve(res);
        })
            .catch(function (err) {
            clearTimeout(timer);
            reject(err);
        });
    });
}
exports.promiseTimeout = promiseTimeout;
//# sourceMappingURL=promise-timeout.js.map